<template>
  <div class="ew-stat" :class="'ew-stat--' + tone">
    <div class="ew-stat-icon"><i :class="icon"></i></div>
    <div class="ew-stat-body">
      <div class="ew-stat-label">{{ label }}</div>
      <div v-if="loading" class="ew-skeleton ew-stat-skeleton"></div>
      <div v-else class="ew-stat-value">{{ value }}</div>
      <div v-if="hint" class="ew-stat-hint">{{ hint }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    icon: { type: String, default: 'bi bi-graph-up' },
    // navy | magenta | success | warning | danger | neutral
    tone: { type: String, default: 'navy' },
    hint: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.ew-stat {
  --tone: #031d7d;
  --tone-bg: #e8ebf5;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  height: 100%;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #eceef5;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(16, 24, 64, 0.06);
}

.ew-stat--magenta { --tone: #a80b5f; --tone-bg: #f8e7f0; }
.ew-stat--success { --tone: #15803d; --tone-bg: #e7f4ec; }
.ew-stat--warning { --tone: #d97706; --tone-bg: #fdf2e3; }
.ew-stat--danger { --tone: #d92d20; --tone-bg: #fdecea; }
.ew-stat--neutral { --tone: #6b7185; --tone-bg: #f0f1f5; }

.ew-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--tone-bg);
  color: var(--tone);
  font-size: 1.15rem;
}

.ew-stat-body {
  min-width: 0;
}

.ew-stat-label {
  color: #6b7185;
  font-size: 0.8rem;
  font-weight: 500;
}

.ew-stat-value {
  margin-top: 2px;
  color: #1c2030;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.ew-stat-skeleton {
  width: 96px;
  height: 1.45rem;
  margin-top: 6px;
}

.ew-stat-hint {
  margin-top: 2px;
  color: #9aa0b1;
  font-size: 0.75rem;
}

@media (max-width: 575.98px) {
  .ew-stat {
    padding: 14px;
  }

  .ew-stat-icon {
    display: none;
  }

  .ew-stat-value {
    font-size: 1.15rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/StatCard.vue